exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxt-user-single-wrap .yxt-user-tree[data-v-68e331dc]{width:360px !important}\n", ""]);

